"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  areCookiesEnabled: () => areCookiesEnabled,
  isCompatibleTouchDevice: () => isCompatibleTouchDevice,
  isDesktopOperatingSystem: () => isDesktopOperatingSystem,
  isMacOSOperatingSystem: () => isMacOSOperatingSystem,
  isMobileOperatingSystem: () => isMobileOperatingSystem,
  isNativeApp: () => isNativeApp,
  isNonDesktopMac: () => isNonDesktopMac,
  isOldBrowser: () => isOldBrowser,
  isStandalone: () => isStandalone,
  isTabletOperatingSystem: () => isTabletOperatingSystem,
  isTouchDevice: () => isTouchDevice
});
module.exports = __toCommonJS(src_exports);

// src/device.ts
var getOperatingSystem = () => {
  if (typeof navigator === "undefined") {
    return null;
  }
  const userAgent = navigator.userAgent;
  switch (true) {
    case /Windows/.test(userAgent):
      return "Windows";
    case /Macintosh|Mac OS X/.test(userAgent):
      return "MacOS";
    case /Linux/.test(userAgent):
      return "Linux";
    default:
      return null;
  }
};
var isMacOSOperatingSystem = () => {
  return getOperatingSystem() === "MacOS";
};
var isTouchDevice = () => {
  if (typeof navigator === "undefined") {
    return false;
  }
  return !!navigator.maxTouchPoints;
};
var isCompatibleTouchDevice = () => {
  return isTouchDevice() && navigator.maxTouchPoints > 2;
};
var isDesktopOperatingSystem = () => {
  return !isMobileOperatingSystem() && !isTabletOperatingSystem();
};
var isMacMobile = (userAgent) => /iPhone/.test(userAgent) || /iPod/.test(userAgent);
var isMacTablet = (userAgent) => /iPad/.test(userAgent);
var isIpadProTablet = () => (
  // iPad Pro and Air devices have the same user agent as other Mac devices,
  // but they also support multiple touch points
  isMacOSOperatingSystem() && isCompatibleTouchDevice() && !isMobileOperatingSystem()
);
var isAndroidTablet = (userAgent) => /Android/.test(userAgent) && !/Mobi/i.test(userAgent);
var isChromeOsTablet = (userAgent) => /CrOS/.test(userAgent) && !/x86_64/.test(userAgent);
var isTabletOperatingSystem = () => {
  if (typeof navigator === "undefined") {
    return false;
  }
  const { userAgent } = navigator;
  return isCompatibleTouchDevice() && (isMacTablet(userAgent) || isIpadProTablet() || isAndroidTablet(userAgent) || isChromeOsTablet(userAgent));
};
var isNonDesktopMac = () => {
  if (typeof navigator === "undefined") {
    return false;
  }
  const { userAgent } = navigator;
  return isMacMobile(userAgent) || isMacTablet(userAgent) || isIpadProTablet();
};
var isMobileOperatingSystem = () => {
  if (typeof navigator === "undefined") {
    return false;
  }
  const { userAgent } = navigator;
  return /Mobi/i.test(userAgent) && // IPad Mini tends to report as mobile, but it is not
  !isMacTablet(userAgent);
};
var areCookiesEnabled = () => {
  return navigator.cookieEnabled;
};

// src/isOldBrowser.ts
function isOldBrowser() {
  if (typeof navigator === "undefined") {
    return false;
  }
  const { userAgent } = navigator;
  const isChrome = /Chrome\/([0-9.]+)/.exec(userAgent);
  if (isChrome && Number(isChrome[1].split(".")[0]) < 85) {
    return true;
  }
  const isFirefox = /Firefox\/([0-9.]+)/.exec(userAgent);
  if (isFirefox && Number(isFirefox[1].split(".")[0]) < 80) {
    return true;
  }
  const isEdge = /Edg\/([0-9.]+)|Edge\/([0-9.]+)/.exec(userAgent);
  if (isEdge && Number((isEdge[1] || isEdge[2]).split(".")[0]) < 85) {
    return true;
  }
  const isIE = /MSIE\s([0-9.]+)|Trident.*rv:([0-9.]+)/.exec(userAgent);
  if (isIE) {
    return true;
  }
  const isSafari = /Version\/([0-9.]+).*Safari/.exec(userAgent);
  if (isSafari && Number(isSafari[1]) < 14.1) {
    return true;
  }
  return false;
}

// src/isNativeApp.ts
var isNativeApp = () => {
  return typeof window !== "undefined" && "ReactNativeWebView" in window;
};

// src/isStandalone.ts
var isStandalone = () => {
  if (typeof window === "undefined") {
    return false;
  }
  return window.matchMedia("(display-mode: standalone)").matches || // PWA
  !!window.navigator.standalone || // iOS home screen
  isNativeApp();
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  areCookiesEnabled,
  isCompatibleTouchDevice,
  isDesktopOperatingSystem,
  isMacOSOperatingSystem,
  isMobileOperatingSystem,
  isNativeApp,
  isNonDesktopMac,
  isOldBrowser,
  isStandalone,
  isTabletOperatingSystem,
  isTouchDevice
});
